'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rem = rem;

var _type = require('../settings/type');

// Pixels to Rem
// -----------------------------------------------------------------------------
// Convert a pixel value to a rem value.
// -----------------------------------------------------------------------------
function rem(pixels) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _type.fontSize)('root');

    return parseInt(pixels, 10) / parseInt(context, 10) + 'rem';
}
//# sourceMappingURL=unit.js.map
// =============================================================================
// UNIT (Tools)
// =============================================================================


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/tools/unit.js